import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { StyleClassModule } from 'primeng/styleclass';
import { AuthService } from '../../../core/services/auth.service';
import { SharedModule } from '../../../shared/shared.module';
import { LayoutService } from '../../service/layout.service';
import { ConfiguratorComponent } from '../configurator/configurator.component';

@Component({
    selector: 'app-topbar',
    standalone: true,
    imports: [RouterModule, CommonModule, StyleClassModule, ConfiguratorComponent, SharedModule],
    templateUrl: './topbar.component.html'
})
export class TopbarComponent implements OnInit {
    items!: MenuItem[];
    isProfileMenuOpen = false;

    userName: string = '';
    userEmail: string = '';

    constructor(public layoutService: LayoutService, private authService: AuthService, private router: Router) {
    }

    ngOnInit() {
        this.authService.currentUser.subscribe(({user}) => {
            if (user) {
                this.userName = user.name;
                this.userEmail = user.email;
            }
        });
    }

    toggleProfileMenu() {
        this.isProfileMenuOpen = !this.isProfileMenuOpen;
    }

    closeProfileMenu() {
        setTimeout(() => this.isProfileMenuOpen = false, 150);
    }

    goToProfile() {
        this.router.navigate(['/profile']);
    }

    logout(): void {
        this.authService.logout();
    }

    toggleDarkMode() {
        this.layoutService.layoutConfig.update((state) => ({ ...state, darkTheme: !state.darkTheme }));
        this.saveConfigs();
    }

    saveConfigs() {
        const config = this.layoutService.layoutConfig();
        this.layoutService.saveLayout(config);
    }
}
